'use client';

import { PropsWithChildren } from 'react';

import { AppRouterCacheProvider } from '@mui/material-nextjs/v13-appRouter';
import { ThemeProvider } from '@mui/material/styles';

import theme from '@/styles/themes';
import useFunkyConsoleMessage from '@/utils/hooks/useFunkyConsoleMessage';

const Providers = ({ children }: PropsWithChildren) => {
  useFunkyConsoleMessage();

  return (
    <AppRouterCacheProvider>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </AppRouterCacheProvider>
  );
};

export default Providers;
